import { Button, Tooltip } from '@nextui-org/react'
import { GitBranchIcon } from 'lucide-react'
import { useRouter } from 'next/router'
import { TUTORIAL_PAGE_SLUG } from 'website/src/lib/env'
import {
    useRootProps,
    useAwarenessStates,
    DisableForAnons,
} from 'website/src/lib/hooks'
import { getGithubInstallUrl, getGithubUrlForPage } from 'website/src/lib/utils'
import { CreateRepoButton } from 'website/src/pages/org/[orgId]/p/[siteSlug]/settings'

export function GithubSyncButton({}) {
    const {
        githubBranch,
        isPR,
        githubOwner,
        githubRepo,
        installationId,
        pageSlug,
        userId,
        orgId,
        siteId,
        siteName,
    } = useRootProps()

    const githubStates = useAwarenessStates('github')
    const saving = !!githubStates?.some((x) => x.saving)
    const waiting = !!githubStates?.some((x) => x.waiting)
    const showTutorialTooltip = githubRepo && pageSlug === TUTORIAL_PAGE_SLUG
    const content = (() => {
        if (!installationId || !githubRepo) {
            return 'Connect Github'
        }
        if (showTutorialTooltip) {
            return 'Not Synced'
        }
        if (saving) {
            return 'Syncing...'
        }
        if (waiting) {
            return 'Sync Scheduled'
        }
        return 'GitHub Synced'
    })()

    const router = useRouter()
    if (isPR) {
        return null
    }

    const url = (() => {
        if (!installationId) {
            return getGithubInstallUrl({
                userId,
                orgId,
                siteId,
                redirectToPath: router.asPath,
                flowType: 'update-integration',
            })
        }
        if (githubRepo) {
            return getGithubUrlForPage({
                githubBranch,
                githubOwner,
                githubRepo,
                pageSlug,
            })
        }
    })()
    const icon = (
        <GitBranchIcon className='justify-self-start shrink-0 w-[14px]' />
    )
    if (installationId && !githubRepo) {
        return (
            <DisableForAnons>
                <CreateRepoButton {...{ orgId, siteId, siteName, githubOwner }}>
                    <Button startContent={icon}>Create Github Repo</Button>
                </CreateRepoButton>
            </DisableForAnons>
        )
    }
    const loading = saving || waiting
    return (
        <DisableForAnons>
            <Tooltip
                // placement='bottom'
                content={
                    showTutorialTooltip
                        ? `${TUTORIAL_PAGE_SLUG} is a demo page`
                        : null
                }
            >
                <Button
                    startContent={loading ? null : icon}
                    // variant='flat'
                    as={url ? 'a' : 'button'}
                    target='_blank'
                    href={url}
                    // size='sm'
                    isLoading={loading}
                    className='truncate relative tracking-tighter w-[160px] flex '
                >
                    <div className='truncate'>{content}</div>
                </Button>
            </Tooltip>
        </DisableForAnons>
    )
}
